import { render, staticRenderFns } from "./WMercadoPago.vue?vue&type=template&id=6bcde34a&"
import script from "./WMercadoPago.vue?vue&type=script&lang=js&"
export * from "./WMercadoPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports